import * as React from 'react';
import NewCloseButton from '../../common/NewCloseButton';

interface PageJumpToolHeaderProps {
  onCloseButtonClick: () => void;
}

const containerStyle: React.CSSProperties = {
  width: '100%',
  height: '35px',
};

const wrapperStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  marginLeft: '20px',
  marginRight: '5px',
  marginTop: '5px',
};

const titleStyle: React.CSSProperties = {
  fontSize: '1em',
  color:'#fff',
  textAlign: 'center',
  width: '157px',
  verticalAlign: 'middle',
  paddingTop: '5px',
  fontWeight: 'bold',
};

const PageJumpToolHeader: React.SFC<PageJumpToolHeaderProps> = (props) => {
  const { onCloseButtonClick } = props;

  return (
    <div style={containerStyle}>
      <div style={wrapperStyle}>
        <div style={titleStyle}>
          ページ入力
        </div>
        <NewCloseButton onClick={onCloseButtonClick} />
      </div>
    </div>
  );
};

export default PageJumpToolHeader;
